export default __webpack_public_path__ + "static/scam-alert-image-3-b614e80044c240758d7228977aa88484.webp";